import { combineReducers } from 'redux';

import { generateYesterdayDate } from '../Common/utils';

import {
  SET_REJECTED_FILTERS,
  SET_CURRENT_SELECTED_REJECTED,
  SET_CURRENT_REJECTED_DETAILS,
  SET_REJECTED_GRID_SORT_CRITERIA,
  SET_REJECTED_PAGINATION,
  RESET_REJECTED_FILTERS,
} from './actionTypes';

const yesterdayDate = generateYesterdayDate();

const rejectedFiltersInitialState = {
  firstReceivedOn: yesterdayDate,
  lastReceivedOn: yesterdayDate,
  partnerID: 'ALL',
  agencyID: 'ALL',
  referenceNumber: '',
};

const currentRejectedInitialState = {
  agency: '',
  count: '',
  errors: '',
  firstReceivedOn: '',
  lastReceivedOn: '',
  partner: '',
  reference: '',
  rejectedId: '',
};

const currentRejectedDetailsInitialState = {
  visitPayload: {},
};

const rejectedGridSortCriteriaInitialState = {
  sortByColumn: 'partnerID',
  sortDirection: 'up',
};

const rejectedPaginationInitialState = {
  pageNumber: 1,
  pageSize: 25,
  totalRecords: 0,
};

const currentSelectedRejectedReducer = (
  state = currentRejectedInitialState,
  { type = '', rejected = { ...currentRejectedInitialState } } = {},
) => {
  switch (type) {
    case SET_CURRENT_SELECTED_REJECTED:
      return {
        ...state,
        ...rejected,
      };

    default:
      return state;
  }
};

const currentRejectedDetailsReducer = (
  state = currentRejectedDetailsInitialState,
  { type = '', details = { ...currentRejectedDetailsInitialState } } = {},
) => {
  switch (type) {
    case SET_CURRENT_REJECTED_DETAILS:
      return {
        ...state,
        ...details,
      };

    default:
      return state;
  }
};

const rejectedFiltersReducer = (
  state = rejectedFiltersInitialState,
  { type = '', filters = { ...rejectedFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_REJECTED_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_REJECTED_FILTERS:
      return {
        ...state,
        ...rejectedFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const currentRejectedGridSortCriteriaReducer = (
  state = rejectedGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...rejectedGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_REJECTED_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const rejectedPaginationReducer = (
  state = rejectedPaginationInitialState,
  { type = '', pagination = { ...rejectedPaginationInitialState } } = {},
) => {
  switch (type) {
    case SET_REJECTED_PAGINATION:
      return {
        ...state,
        ...pagination,
      };

    default:
      return state;
  }
};

const rejectedReducer = combineReducers({
  rejectedFilters: rejectedFiltersReducer,
  currentSelectedRejected: currentSelectedRejectedReducer,
  currentRejectedDetails: currentRejectedDetailsReducer,
  rejectedGridSortCriteria: currentRejectedGridSortCriteriaReducer,
  rejectedPagination: rejectedPaginationReducer,
});

export {
  rejectedReducer,
  rejectedFiltersInitialState,
  rejectedGridSortCriteriaInitialState,
  rejectedPaginationInitialState,
};
